import styled from '@emotion/styled';
import { AccountContent } from 'src/domains/players/webview/components/Account/accountParts/Account.style';
import { withConfig } from 'src/withConfig';

export const Wrapper = withConfig(theme => styled(AccountContent, { label: 'Wrapper' })`
    padding: ${theme.star.padding.large};
    display: flex;
    flex-flow: column nowrap;
    gap: ${theme.star.gap.xLarge};
    min-height: 100%;
`);

export const SectionWrapper = withConfig(theme => styled('div', { label: 'SectionWrapper' })`
    padding: ${theme.star.padding.large} 0;
    display: flex;
    flex-flow: column nowrap;
`);

export const Separator = withConfig(theme => styled('div', { label: 'Separator' })`
    width: 100%;
    height: 1px;
    background-color: ${theme.star.accountLinks.borderColor};
`);


export const Header = withConfig(theme => styled('h2', { label: 'Header' })`
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.5;
    margin: 0;
`);
